import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { getErrorDescription } from 'src/app/utils/messages';
import { SmLogoComponent } from '../../components/sm-logo/sm-logo.component';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [
    RouterModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    CommonModule,
    MatIconModule,
    SmLogoComponent
  ],
  templateUrl: './error.component.html'
})
export default class ComponentError {
  public error_code: any;
  public error_title: any;
  public error_description: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe(async (params: any) => {
      this.error_code = params.error_code;

      const { message, description } = getErrorDescription(this.error_code);
      this.error_description = description;
      this.error_title = message;
    });
  }
}
